import { autoSort } from "./autoSort";
import { getBottomOrRightPosition } from "./getBottomOrRightPosition";
import loadAvailableImg from "./loadAvailableImg";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import func from "@uikit/func";

function humanizeBytes(bytes) {
  if (bytes === 0) {
    return "0 Bytes";
  }
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const size = parseFloat((bytes / Math.pow(k, i)).toFixed(2));
  return `${size} ${sizes[i]}`;
}

async function getImageData(res) {
  const s3Path = res.headers.get("X-Brain-S3-Path") || "";
  let value = "";
  if (!func.isEmpty(s3Path)) {
    value = `${settings.S3CDN}${encodeURI(s3Path)}`;
  } else {
    const blob = await res.blob();
    value = URL.createObjectURL(blob);
    URL.revokeObjectURL(value);
  }
  return value;
}
async function decoderToText(res) {
  const reader = await res.getReader();
  const result = await reader.read();
  const decoder = new TextDecoder();
  return decoder.decode(result.value);
}
async function handleResponseStatusData(res, start) {
  if (!res) return;
  const end = Date.now();
  const diff = end - start;
  const size = res.headers.get("content-length");
  const contentType = res.headers.get("content-type");
  const responseHeaders = Object.fromEntries(res.headers.entries());
  let data = {};
  let value = "";

  switch (true) {
    case contentType.includes("image"):
      value = await getImageData(res);
      data = {
        type: "image",
        value,
      };
      break;
    case contentType.includes("json"):
      try {
        value = await res.clone().json();
        data = {
          type: "json",
          value,
        };
      } catch (_) {
        value = await res.text();
        data = {
          type: "text",
          value,
        };
      }
      break;
    case contentType.includes("html"):
      value = await decoderToText(res.body);
      data = {
        type: "html",
        value,
      };
      break;
    default:
      value = await decoderToText(res.body);
      let finalRes = value;
      try {
        finalRes = JSON.parse(value);
      } catch (error) {}
      data = {
        type: "text",
        value: finalRes,
      };
  }

  return {
    status: res.status,
    statusText: res.statusText,
    time: `${(diff / 1000).toFixed(2)} s`,
    size: humanizeBytes(size),
    data,
    responseHeaders,
  };
}

function replaceInputAndCustomVars(params) {
  const inputTestReg = /<input>/gi;
  let { variableList, nodes, prompt, nodeText, isNode = false, setVariableList } = params;

  const variableRegs = variableList.map(x => {
    const currentNode = nodes.find(y => y.id === x.node.id);
    const currentNodeTextAreaValue = currentNode?.data?.textAreaValue;
    let recentValue = x.node.data.textAreaValue;

    if (!func.isEmpty(currentNodeTextAreaValue)) {
      recentValue = currentNodeTextAreaValue;
      // 更新variableList保存的textAreaValue
      const tempVariableList = [...variableList];
      const currVarIdx = tempVariableList.findIndex(y => y.name === x.name);
      tempVariableList.splice(currVarIdx, 1, {
        name: x.name,
        node: {
          ...x.node,
          data: {
            ...x.node.data,
            textAreaValue: currentNodeTextAreaValue,
          },
        },
      });
      setVariableList([...tempVariableList]);
    }

    return {
      reg: new RegExp(`<${x.name}>`, "g"),
      value: recentValue || "",
    };
  });

  // 匹配自定义变量并替换值
  if (!func.isEmpty(variableRegs)) {
    variableRegs.forEach(x => {
      prompt = prompt.replace(x.reg, x.value);
    });
  }

  // 替换<input>变量
  if (inputTestReg.test(prompt)) {
    prompt = prompt.replace(inputTestReg, nodeText);
  } else {
    if (isNode) {
      prompt = `${prompt}${nodeText}`;
    }
  }
  return prompt;
}
function moveCursorToEnd(el) {
  const end = el?.value?.length || 0;
  el.setSelectionRange(end, end);
}

// 根据displayType判定textAreaValue不为string的情况下应该返回的字段
function getTextFromTextAreaValueByType(data) {
  // if(typeof data.textAreaValue === 'string') return data.textAreaValue

  if (data.displayType === "askBrain") {
    return data.textAreaValue.answer;
  }

  // todo: 还需要处理其他textAreaValue不为string的情况
  return data.textAreaValue;
}

function createIdByNodeType(type, id) {
  let nodeId = "";
  switch (type) {
    case "CustomNode":
      nodeId = `editor-${id}`;
      break;

    case "customNewEdge":
      nodeId = `new-edge-${id}`;
      break;

    case "customGroup":
      nodeId = `group-${id}`;
      break;

    default:
      nodeId = `editor-${id}`;
      break;
  }
  return nodeId;
}

function createIdByEdgeType(type, id) {
  let edgeId = "";
  switch (type) {
    case "customNewLine":
      edgeId = `new-line-${id}`;
      break;

    case "customEdge":
      edgeId = `edge-${id}`;
      break;

    default:
      edgeId = `edge-${id}`;
      break;
  }
  return edgeId;
}

export default {
  autoSort,
  getBottomOrRightPosition,
  getTextFromTextAreaValueByType,
  humanizeBytes,
  handleResponseStatusData,
  replaceInputAndCustomVars,
  moveCursorToEnd,
  loadAvailableImg,
  createIdByNodeType,
  createIdByEdgeType,
};
